export default "__VITE_ASSET__28bc92c9__"